module.exports = __webpack_public_path__ + "img/ez-slot-category-casino-mobile.ddde4bde.png";